import isStaticDateHoliday from './isStaticDateHoliday';
import isMovableDateHoliday from './isMovableDateHoliday';
import isMemorialDay from './isMemorialDay';
import isGoodFriday from './isGoodFriday';
import isVictoriaDay from './isVictoriaDay';
const jonesMarketStaticHolidaysCA = [{
  month: 0,
  date: 1,
  saturdayAdjustment: 2,
  sundayAdjustment: 1,
  locale: 'en-ca'
},
// New Years Day
{
  month: 6,
  date: 1,
  saturdayAdjustment: 2,
  sundayAdjustment: 1,
  locale: 'en-ca'
},
// Canada Day
{
  month: 11,
  date: 25,
  saturdayAdjustment: 2,
  sundayAdjustment: 1,
  locale: 'en-ca'
},
// Christmas
{
  month: 11,
  date: 26,
  saturdayAdjustment: 2,
  sundayAdjustment: 2,
  locale: 'en-ca',
  boxingDaySundayAdjustment: 2,
  boxingDayMondayAdjustment: 1
} // Boxing Day
];

const jonesMarketStaticHolidaysUS = [{
  month: 0,
  date: 1,
  saturdayAdjustment: 0,
  sundayAdjustment: 1,
  locale: 'en-us'
},
// New Years Day
{
  month: 5,
  date: 19,
  saturdayAdjustment: -1,
  sundayAdjustment: 1,
  locale: 'en-us'
},
// Juneteenth
{
  month: 6,
  date: 4,
  saturdayAdjustment: -1,
  sundayAdjustment: 1,
  locale: 'en-us'
},
// 4th of July
{
  month: 11,
  date: 25,
  saturdayAdjustment: -1,
  sundayAdjustment: 1,
  locale: 'en-us'
} // Christmas
];

/* Static holidays are days that have the same date every year. */
const staticDateHolidays = holidayLocale => {
  let holidayList = [];
  if (holidayLocale === 'en-ca' || holidayLocale === 'all') {
    holidayList = [].concat(jonesMarketStaticHolidaysCA);
  }
  if (holidayLocale === 'en-us' || holidayLocale === 'all') {
    holidayList = [].concat(holidayList, jonesMarketStaticHolidaysUS);
  }
  return holidayList;
};
const movableUSDateJonesMarketHolidays = [{
  month: 0,
  dayOfWeek: 1,
  weekOfMonth: 3
},
// Martin Luther King Jr Day
{
  month: 1,
  dayOfWeek: 1,
  weekOfMonth: 3
},
// Presidents Day
{
  month: 8,
  dayOfWeek: 1,
  weekOfMonth: 1
},
// Labor Day
{
  month: 10,
  dayOfWeek: 4,
  weekOfMonth: 4
} // Thanksgiving
];

const movableCanadaDateJonesMarketHolidays = [{
  month: 7,
  dayOfWeek: 1,
  weekOfMonth: 1
},
// Civic HoliDay
{
  month: 1,
  dayOfWeek: 1,
  weekOfMonth: 3
},
// Family Day
{
  month: 8,
  dayOfWeek: 1,
  weekOfMonth: 1
},
// Labor Day
{
  month: 9,
  dayOfWeek: 1,
  weekOfMonth: 2
} // Thanksgiving
];

/* Movable holidays are days that have a different date each year
and instead are determined by the day/week of the month. */
const movableDateHolidays = holidayLocale => {
  let holidayList = [];
  if (holidayLocale === 'en-ca' || holidayLocale === 'all') {
    holidayList = [].concat(movableCanadaDateJonesMarketHolidays);
  }
  if (holidayLocale === 'en-us' || holidayLocale === 'all') {
    holidayList = [].concat(holidayList, movableUSDateJonesMarketHolidays);
  }
  return holidayList;
};
const getWeekOfMonth = day => Math.ceil(day.date() / 7);
const isJonesMarketHoliday = (day, holidayLocale) => {
  if (!day) return false;
  const month = day.month();
  const date = day.date();
  const dayOfWeek = day.day();
  const weekOfMonth = getWeekOfMonth(day);
  const year = day.year();
  return isStaticDateHoliday(staticDateHolidays(holidayLocale), month, date, dayOfWeek, year) || isMovableDateHoliday(movableDateHolidays(holidayLocale), month, dayOfWeek, weekOfMonth) || isGoodFriday(month, date, dayOfWeek, year) || (holidayLocale === 'en-us' || holidayLocale === 'all') && isMemorialDay(month, date, dayOfWeek, year) || (holidayLocale === 'en-ca' || holidayLocale === 'all') && isVictoriaDay(day);
};
export default isJonesMarketHoliday;
//# sourceMappingURL=isJonesMarketHoliday.js.map